import { EngagementErrorDialogDataModel } from './engagement-error-dialog-data.model';
import { ROUTE_TOKEN_ENGAGEMENTS_BASE } from '../../../../routing-constants';

export abstract class InvalidEngagementStateStrategy implements EngagementErrorDialogDataModel{

  engagementId: number;
  hasAdditionalTasks: boolean;

  constructor(engagementId: number, hasAdditionalTasks: boolean) {
    this.engagementId = engagementId;
    this.hasAdditionalTasks = hasAdditionalTasks;
  }

  abstract getTitle(): string;
  abstract getImagePath(): string;

  getMessage() {
    return '';
  }
  getButtonText() {
    return 'Continue';
  }

  getRoutePath() {
    if (this.hasAdditionalTasks) {
      return '';
    }
    return `${ROUTE_TOKEN_ENGAGEMENTS_BASE}`
  }
}
